// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-insured-numbers-panel .sms-insureds-filter-form .insureds-filter-form-buttons {
  text-align: right;
  padding-top: 10px;
}
.search-insured-numbers-panel .sms-insureds-filter-form .ant-form-item {
  display: flex;
  margin-bottom: 0 !important;
}
.search-insured-numbers-panel .sms-insureds-filter-form .ant-form-item-label {
  padding: 0 !important;
}
.search-insured-numbers-panel .sms-insureds-filter-form label {
  font-size: 13px !important;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/modals/mass-sms/search-insured-numbers/styles.less"],"names":[],"mappings":"AAAA;EAGM,iBAAA;EACA,iBAAA;AADN;AAHA;EAQM,aAAA;EACA,2BAAA;AAFN;AAPA;EAaM,qBAAA;AAHN;AAVA;EAiBM,0BAAA;EACA,gBAAA;AAJN","sourcesContent":[".search-insured-numbers-panel {\n  .sms-insureds-filter-form {\n    .insureds-filter-form-buttons {\n      text-align: right;\n      padding-top: 10px;\n    }\n\n    .ant-form-item {\n      display: flex;\n      margin-bottom: 0 !important;\n    }\n\n    .ant-form-item-label {\n      padding: 0 !important;\n    }\n\n    label {\n      font-size: 13px !important;\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
